import {CompoundConditionSignal} from 'common/src/modules/decisionTree/decisionTree.types';
import {CompoundConditionCardData} from '../../scratchpad/compoundConditionCardScratchpad.types';

/**
 * Validates that a signal exists in the available signals list and returns an enriched signal object.
 * @param signalValue - The signal key/value to set
 * @param signalName - The display name for the signal
 * @param categories - The condition categories for this signal
 * @param cardData - The compound condition card data containing available signals
 * @returns The validated signal object or an error string
 */
export default function setRuleSignal(
  signalValue: string,
  signalName: string,
  categories: number[],
  cardData: CompoundConditionCardData,
): CompoundConditionSignal | string {
  if (
    cardData.availableSignals?.length &&
    !cardData.availableSignals.some((s) => s.value === signalValue)
  ) {
    return `Signal "${signalValue}" is not available. Valid signals are: ${cardData.availableSignals.map((s) => s.value).join(', ')}`;
  }

  return {
    name: signalName,
    value: signalValue,
    categories,
  };
}
